import { render, staticRenderFns } from "./RolesUsuario.vue?vue&type=template&id=622cbb82&"
import script from "./RolesUsuario.vue?vue&type=script&lang=js&"
export * from "./RolesUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports